(function () {
  'use strict';

  function updateSliderInPanel(panel) {
    if (!panel) return;
    const slideshow = panel.querySelector('slideshow-container');
    if (slideshow) {
      if (slideshow.swiper) {
        slideshow.swiper.update();
      } else if (typeof slideshow.updateSwiper === 'function') {
        slideshow.updateSwiper();
      }
    }
  }

  class HomeFeaturedTabbedSlider extends HTMLElement {
    constructor() {
      super();
      this._onTabClick = this._onTabClick.bind(this);
      this._onKeydown  = this._onKeydown.bind(this);
    }

    connectedCallback() {
      this.tabs   = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click',   this._onTabClick);
        tab.addEventListener('keydown', this._onKeydown);
      });

      const activeTab = this.tabs.find((t) => t.classList.contains('is-active'));
      if (activeTab) this._applyBg(activeTab);

      const activePanel = this.querySelector('.home-tabbed-featured__panel.is-active');
      if (activePanel) updateSliderInPanel(activePanel);
    }

    disconnectedCallback() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click',   this._onTabClick);
        tab.removeEventListener('keydown', this._onKeydown);
      });
    }

    _onTabClick(e) {
      this._switchTab(e.currentTarget);
    }

    _onKeydown(e) {
      const idx = this.tabs.indexOf(e.currentTarget);
      const last = this.tabs.length - 1;
      let next = null;

      switch (e.key) {
        case 'ArrowLeft': next = idx === 0    ? last  : idx - 1; break;
        case 'ArrowRight':next = idx === last  ? 0     : idx + 1; break;
        case 'Home':      next = 0;                               break;
        case 'End':       next = last;                            break;
      }

      if (next !== null) {
        e.preventDefault();
        this._switchTab(this.tabs[next]);
      }
    }

    _switchTab(newTab) {
      const targetId = newTab.getAttribute('aria-controls') || newTab.getAttribute('data-home-tab-target');
      if (!targetId) return;

      const newPanel = this.querySelector('#' + targetId);
      if (!newPanel) return;

      // Deactivate all
      this.tabs.forEach((tab) => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
      });
      this.panels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });

      // Activate selected
      newTab.classList.add('is-active');
      newTab.setAttribute('aria-selected', 'true');
      newTab.setAttribute('tabindex', '0');
      newTab.focus();

      newPanel.classList.add('is-active');
      newPanel.hidden = false;

      this._applyBg(newTab);
      updateSliderInPanel(newPanel);
    }

    _applyBg(tab) {
      const bg = tab.getAttribute('data-panel-bg');
      if (bg) this.style.background = bg;
    }
  }

  if (!customElements.get('home-featured-tabbed-slider')) {
    customElements.define('home-featured-tabbed-slider', HomeFeaturedTabbedSlider);
  }

  function initSlidersIn(root) {
    if (!root) return;
    const slideshows = root.querySelectorAll('slideshow-container');
    slideshows.forEach((slideshow) => {
      if (slideshow.swiper) slideshow.swiper.update();
    });
  }

  window._homeFeaturedTabSlider = window._homeFeaturedTabSlider || {};
  window._homeFeaturedTabSlider.initSlidersIn = initSlidersIn;
})();